import { SearchInput } from 'V2Components'
import { Typography } from 'procyon-ui'
import React from 'react'

function Header({ searchKey, onSearchKeyChange }) {
  return (
    <div className='flex justify-between items-center'>
      <Typography style={{ color: 'var(--color-font-base)' }} variant='h3'>
        Users
      </Typography>
      <div className='flex gap-4'>
        <SearchInput sx={{ width: '280px' }} searchKey={searchKey} onChange={onSearchKeyChange} />
        {/* <Button id='users-add-new-btn' onClick={onAddUsersClick}  size='md' variant='primary' icon={faPlus}>
          Add New
        </Button> */}
      </div>
    </div>
  )
}

export { Header }
